<!--
Financial rate and label (in mobile and desktop view)
-->
@if (fcisRateInfo?.rate) {
  <ccwb-price
    class="cc-finance-display__price"
    [size]="size"
    [class.cc-finance-display__price--text-center]="textCentralizeOnMobile"
  >
    <span slot="headline">{{ fcisRateInfo.label }}</span>
    <span slot="price">
      @if ((isMobile$ | async) && vehicle?.priceInformation?.discountedPrice) {
        <ccwb-icon class="cc-finance-display__environmental-bonus-icon" name="consumption" aria-hidden="true" />
      }
      {{ fcisRateInfo.rate }}
      @if (showFinancialCalculatorOpener) {
        <ccwb-icon
          class="cc-finance-display__info-icon"
          [ccTrackClick]="{ category: 'link', label: 'open_finance_layer', action: 'main_navi' }"
          (click)="openFinanceCalculator()"
          (keyup.enter)="openFinanceCalculator()"
          name="bds/calculator/24"
          tabindex="0"
        />
      }
    </span>
  </ccwb-price>
}
